import { withStyles } from "@material-ui/core";
import { createStyles, Theme } from "@material-ui/core/styles";
import * as React from "react";

const styles = (theme: Theme) => createStyles({});

interface IProps {
  handleFinalizeTransaction: () => void;
  transactionId: string;
}

const TransactionResult: React.SFC<IProps> = (props: IProps) => {
  props.handleFinalizeTransaction();
  return (
    <div>
      Verifying transaction {props.transactionId}
      ...
    </div>
  );
};

export default withStyles(styles)(TransactionResult);



// WEBPACK FOOTER //
// ./src/components/TransactionResult.tsx